import { render, staticRenderFns } from "./PickSubject.vue?vue&type=template&id=2bd03974&"
import script from "./PickSubject.vue?vue&type=script&lang=js&"
export * from "./PickSubject.vue?vue&type=script&lang=js&"
import style0 from "./PickSubject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports